import { render, staticRenderFns } from "./NPanelBox.vue?vue&type=template&id=9273342e"
import script from "./NPanelBox.vue?vue&type=script&lang=js"
export * from "./NPanelBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports